import { createRouter, createWebHistory } from 'vue-router'

import activity from './activity'
import auth from './auth'
import billing from './billing'
import blacklist from './blacklist'
import calendar from './calendar'
import globalCalendar from './globalCalendar'
import campaign from './campaign'
import campaignTags from './campaignTags'
import content from './content'
import dashboard from './dashboard'
import error from './error'
import feed from './feed'
import hashTags from './hashTags'
import imagelibrary from './imagelibrary'
import leaderboard from './leaderboard'
import log from './log'
import mynetwork from './myNetwork'
import pluginuninstall from './pluginuninstall'
import reporting from './reporting'
import signup from './signup'
// import smartlinks from './smartlinks'
import store from '@/store'
import tag from './tag'
import tagGroups from './tagGroups'
import task from './task'
import team from './team'
import test from './test'
import topic from './topic'

const routes = [
    ...auth,
    ...dashboard,
    ...feed,
    ...topic,
    ...tag,
    ...tagGroups,
    ...task,
    ...content,
    ...team,
    ...activity,
    ...mynetwork,
    ...log,
    ...campaign,
    ...blacklist,
    ...calendar,
    ...globalCalendar,
    ...signup,
    ...error,
    //    ...smartlinks,
    ...imagelibrary,
    ...test,
    ...reporting,
    ...campaignTags,
    ...hashTags,
    ...leaderboard,
    ...pluginuninstall,
    ...billing,
    {
        path: '/reward',
        name: 'Reward',
        component: () => import('@/views/reward/RewardsView.vue'),
        meta: {
            layout: 'Default',
            abilities: [
                ['view', 'rewards'],
                ['manage', 'rewards'],
            ],
        },
    },
    {
        path: '/changelog',
        name: 'Changelog',
        component: () => import('@/views/changelog/GlobalChangelog.vue'),
        meta: {
            layout: 'Default',
            abilities: [['view', 'changelog']],
        },
    },
    {
        path: '/guest/share',
        name: 'ShareAsGuest',
        component: () => import('@/views/guest/ShareAsGuest.vue'),
        meta: {
            layout: 'Guest',
        },
    },
    {
        path: '/payment',
        name: 'Payment',
        component: () => import('@/views/billing/Payment.vue'),
        meta: {
            layout: 'Default',
            abilities: [['manage', 'billing']],
        },
    },
    {
        path: '/unsubscribed',
        name: 'Unsubscribed',
        component: () => import('@/views/unsubscribed/Unsubscribed.vue'),
        meta: {
            layout: 'Default',
            abilities: [['*']],
        },
    },
    {
        path: '/:pathMatch(.*)',
        name: 'not-found',
        component: () => import('@/views/error/NotFound.vue'),
        meta: {
            layout: 'Error',
        },
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach(async (to, from, next) => {

    if (
        !store.getters.isAuthenticated &&
        !store.getters.isAuthenticatedLimited
    ) {
        // Try refreshing token, but don't crash on failed request
        await store.dispatch('refreshToken').catch((e) => e)
    }

    const token = store.state.auth.token

    if (store.getters.isAuthenticated) {
        if (to.name === 'Login') {
            next('/')
            return
        }
 
		if (to.meta?.abilities?.length > 0 &&
            to.name !== 'Workspace Finder' &&
            to.name !== 'Plugin Authenticated' &&
            to.name !== 'v1 redirect' &&
            to.name !== 'v2 redirect' &&
            to.name !== 'AutoVersion' &&
            to.name !== 'Root') {
			
			if (store.getters.selectedVersion == 1) {
				console.log('bounced - selected version is ' + store.getters.selectedVersion)
				next({ name: 'v1 redirect' })
				return
			}
	
			if (store.getters.workspaceDefaultVersion !== 2 && (store.getters.allowVersionSwitch === false || !store.getters.allRoles?.includes('admin'))) {
				console.log('bounced -- not allowed on v2')
				next({ name: 'v1 redirect' })
				return
			}
			
		}
		
		if (store.getters.isAuthenticated && store.getters.allowVersionSwitch && store.getters.selectedVersion === null) {
			await store.commit('selectVersion', 2)
		}

    }

    let allowed = true
    /** Hoisted so `abilities` stays in scope for logging when navigation is denied. */
    let abilities: any = undefined

    if (to.meta?.abilities?.length > 0) {
    
    	allowed = store.getters.isAuthenticated
        abilities =
            typeof to.meta.abilities == 'function'
                ? to.meta.abilities(to)
                : to.meta.abilities

        // has abilities defined in the route (at least one)		
		// Everyone can open their own member page (profile, settings, report), whatever their
		// role: the route's owner parameter is the signed-in member (as the API's own-settings
		// check does). This also covers an admin impersonating someone.
		const ownerId = to.meta.ownerIdParameter ? to.params[to.meta.ownerIdParameter as string] : null
		const isOwnPage =
			ownerId != null &&
			store.getters.authedMemberInfo?.id != null &&
			String(ownerId) === String(store.getters.authedMemberInfo.id)

		if (store.getters.isAuthenticated && isOwnPage) {
			allowed = true
		} else if (store.getters.isAuthenticated) {
		
			if (typeof to.meta.abilities == 'function' || to.meta.abilities.indexOf('*') === -1) {

				for (const ability of abilities) {
					// "my-" abilities only apply to the member the route is about
					let routeIdValue = null
					if (to.meta.ownerIdParameter && ability[1].indexOf('my-') === 0) {
						routeIdValue = ownerId
					}
					allowed = await store.dispatch('can', {ability, ownerId: routeIdValue})
 					if (allowed) {
						break
					} else if (Object.keys(store.getters.abilities ?? {}).length > 0) {
						console.log('Cannot access route due to missing permissions:')
					} else {
						next({ name: 'Workspace Finder' })
					}
				}
			}
		} else {
			console.log('Cannot access route, not authenticated:')
			console.log(to)		
		}
    }

    if (allowed && to.meta?.superAdminOnly) {
        allowed = !!store.state.auth.roles?.includes('superadmin')
    }

    if (allowed) {
        next()
    } else {
    	if (store.getters.isAuthenticated) {
    		console.log('Not allowed but authenticated, redirecting to root.')
            console.log(from)
            console.log(abilities)
            console.log(store.getters.abilities)
            next({name: 'Root'})
    	} else {
    		console.log('login')
    		next({
    			name: 'Login',
    			query: {
    				...to.query,
    				redirect: to.fullPath,
    			},
    		})
    	}
    }

    store.commit('updateRouting', true)
})

router.afterEach(() => {
    store.commit('updateRouting', false)
})

export default router
